import { Component } from '@angular/core';
import { LoginTemplateComponent } from '../shared/login-template/login-template.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [LoginTemplateComponent],
})
export class LoginComponent {}
